module.exports = __webpack_public_path__ + "static/sec2-637668170fca2cb7eb302a0e2d60abff.png";